'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgTeam(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 8.375c.815 0 1.535.195 2.12.45.54.24.88.78.88 1.365v.31c0 .275-.225.5-.5.5h-5a.501.501 0 01-.5-.5v-.305c0-.59.34-1.13.88-1.365A5.22 5.22 0 018 8.375zM4 8.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm.565.55C4.38 9.02 4.195 9 4 9c-.495 0-.965.105-1.39.29-.37.16-.61.52-.61.925v.285c0 .275.225.5.5.5h1.75v-.805c0-.415.115-.805.315-1.145zM12 8.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm2 1.715c0-.405-.24-.765-.61-.925A3.475 3.475 0 0012 9c-.195 0-.38.02-.565.05.2.34.315.73.315 1.145V11h1.75c.275 0 .5-.225.5-.5v-.285zM8 5c.83 0 1.5.67 1.5 1.5S8.83 8 8 8s-1.5-.67-1.5-1.5S7.17 5 8 5z", fill: "currentColor" }))));
}

module.exports = SvgTeam;
//# sourceMappingURL=Team.js.map
